import { getPathname, getHostname } from './dom';
import { getCurrentCulture as gcc } from '@vp/culture-resolution-core';

export const getCurrentCulture: () => string = () => {
  const hostname: string = getHostname();
  const pathname: string = getPathname();

  return gcc(hostname, pathname);
};
